import { combineReducers } from "redux";
import { authReducer, AuthState, initialAuthState } from "./auth";
import { globalDataReducer, GlobalDataState, initialGlobalDataState } from './globalData/globalDataReducer'
import { userDataReducers, UserDataState, initialUserDataState } from './userData/userDataReducer'
import { documentsReducer, DocumentsState, initialDocumentsState } from './documents/documentsReducer'
import { documentsAdditionalDataReducer, DocumentsAdditionalData, initialDocumentsAdditionalDataState } from './documentsAdditionalData/documentsAdditionalDataReducer'
import { InputAutocompleteState, inputAutocompleteReducer, initialInputAutoCompleteState } from "./inputAutocomplete/inputAutocompleteReducer";
import { tasksReducer, TasksState, initialTasksState } from './tasks'
import {chatDataReducer, ChatData, initialChatDataState} from './chatData/chatDataReducer'
import {activitiesReducer, ActivitiesState, initialActivitiesState} from './activities/activitiesReducer'
import { FeedItemsState, feedItemsReducer, initialFeedItemsState } from "./feed-items/feedItemsReducer";
import { StoriesNavigationState, storiesNavigationReducer, initialStoriesNavigationState } from "./storiesNavigation";
import {timeTrackingReducer, initialTimeTrackingState} from './timeTracking/timeTrackingReducer'
import { TimeTrackerState } from "../../models/TimeTracking";
import { channelReducer, ChannelState, initialChannelState } from "./channel";

export interface DataState {
    auth: AuthState
    userData: UserDataState
    feedItems: FeedItemsState
    documents: DocumentsState
    documentsAdditionalData: DocumentsAdditionalData
    chatData: ChatData
    globalData: GlobalDataState
    inputAutocomplete: InputAutocompleteState
    tasks: TasksState,
    activities: ActivitiesState,
    storiesNavigation: StoriesNavigationState,
    timeTracking: TimeTrackerState,
    channel: ChannelState,

}

export const dataReducer = combineReducers<DataState>({
    auth: authReducer,
    userData: userDataReducers,
    documents: documentsReducer,
    feedItems: feedItemsReducer,
    documentsAdditionalData: documentsAdditionalDataReducer,
    chatData: chatDataReducer,
    globalData: globalDataReducer,
    inputAutocomplete: inputAutocompleteReducer,
    tasks: tasksReducer,
    activities: activitiesReducer,
    storiesNavigation: storiesNavigationReducer,
    timeTracking: timeTrackingReducer,
    channel: channelReducer,
})

export const initialDataState: DataState = {
    auth: initialAuthState,
    userData: initialUserDataState,
    documents: initialDocumentsState,
    feedItems: initialFeedItemsState,
    documentsAdditionalData: initialDocumentsAdditionalDataState,
    chatData: initialChatDataState,
    globalData: initialGlobalDataState,
    inputAutocomplete: initialInputAutoCompleteState,
    tasks: initialTasksState,
    activities: initialActivitiesState,
    storiesNavigation: initialStoriesNavigationState,
    timeTracking: initialTimeTrackingState,
    channel: initialChannelState,
}
